// Do not modify, this file was generated
// to modify, reference the files in dibs-sassy/src/colors/*

export const colors = {
    sassyColorAlertPrimary: '#cc0000',
    sassyColorAlertSecondary: '#950808',
    sassyColorAlertTertiary: '#fedcde',
    sassyColorWarningPrimary: '#f07f04',
    sassyColorWarningSecondary: '#ffc100',
    sassyColorSuccessPrimary: '#66a559',
    sassyColorSuccessSecondary: '#2a7140',
    sassyColorSuccessTertiary: '#aedfa3',
    sassyColorBuyerPrimary: '#c2a661',
    sassyColorBuyerSecondary: '#a48e45',
    sassyColorBuyerTertiary: '#f6f3eb',
    sassyColorBuyerTertiaryAlt: '#e8dfcd',
    sassyColorBuyerPrimaryIphone: '#cca738',
    sassyColorDealerPrimary: '#436b93',
    sassyColorDealerSecondary: '#204664',
    sassyColorDealerTertiary: '#dee3eb',
    sassyColorDealerTertiaryAlt: '#d8ecf5',
    sassyColorWhite: '#fff',
    sassyColorAlabaster: '#fbfbfb',
    sassyColorMoonstone: '#f3f3f3',
    sassyColorDolphin: '#ddd',
    sassyColorStorm: '#bbb',
    sassyColorIron: '#888',
    sassyColorSatan: '#666',
    sassyColorCharcoal: '#444',
    sassyColorNoir: '#222',
    sassyColorPitchBlack: '#000',
    sassyColorOverlayBackground: 'rgba(0, 0, 0, 0.7)',
    sassyColorOverlayLight: 'rgba(255, 255, 255, 0.4)',
    sassyColorInternalPrimary: '#559b5e',
    sassyColorInternalSecondary: '#2a7140',
    sassyColorInternalTertiary: '#b8e7c8',
    sassyColorMarketingSale: '#950808',
    sassyColorNftWine: '#610034',
    sassyColorMutedAquamarine: '#aabeb9',
    sassyColorMedalBronze: '#a06931',
    sassyColorMedalSilver: '#637583',
    sassyColorMedalGold: '#8c7236',
    sassyColorMedalPlatinum: '#727383',
    sassyColorPinterestPrimary: '#e00002',
    sassyColorFacebookPrimary: '#3b5998',
    sassyColorInstagramPrimary: '#275a85',
    sassyColorLinkedinPrimary: '#007bb6',
    sassyColorTwitterPrimary: '#4099ff',
    sassyColorDesignManagerPrimary: '#4bc7e7',
    sassyColorDesignManagerSecondary: '#4f8bc0',
    sassyColorDesignManagerTertiary: '#45545f',
    sassyColorTradePrimary: '#0f8d88',
    sassyColorTradeSecondary: '#0d7d77',
    sassyColorTradeTertiary: '#e7f4f3',
    sassyColorTradeMember: '#666',
} as const;
export const colorPrefix = 'sassyColor' as const;
export const colorVars = {
    sassyColorAlertPrimary: '$sassy-color-alert-primary',
    sassyColorAlertSecondary: '$sassy-color-alert-secondary',
    sassyColorAlertTertiary: '$sassy-color-alert-tertiary',
    sassyColorWarningPrimary: '$sassy-color-warning-primary',
    sassyColorWarningSecondary: '$sassy-color-warning-secondary',
    sassyColorSuccessPrimary: '$sassy-color-success-primary',
    sassyColorSuccessSecondary: '$sassy-color-success-secondary',
    sassyColorSuccessTertiary: '$sassy-color-success-tertiary',
    sassyColorBuyerPrimary: '$sassy-color-buyer-primary',
    sassyColorBuyerSecondary: '$sassy-color-buyer-secondary',
    sassyColorBuyerTertiary: '$sassy-color-buyer-tertiary',
    sassyColorBuyerTertiaryAlt: '$sassy-color-buyer-tertiary-alt',
    sassyColorBuyerPrimaryIphone: '$sassy-color-buyer-primary-iphone',
    sassyColorDealerPrimary: '$sassy-color-dealer-primary',
    sassyColorDealerSecondary: '$sassy-color-dealer-secondary',
    sassyColorDealerTertiary: '$sassy-color-dealer-tertiary',
    sassyColorDealerTertiaryAlt: '$sassy-color-dealer-tertiary-alt',
    sassyColorWhite: '$sassy-color-white',
    sassyColorAlabaster: '$sassy-color-alabaster',
    sassyColorMoonstone: '$sassy-color-moonstone',
    sassyColorDolphin: '$sassy-color-dolphin',
    sassyColorStorm: '$sassy-color-storm',
    sassyColorIron: '$sassy-color-iron',
    sassyColorSatan: '$sassy-color-satan',
    sassyColorCharcoal: '$sassy-color-charcoal',
    sassyColorNoir: '$sassy-color-noir',
    sassyColorPitchBlack: '$sassy-color-pitch-black',
    sassyColorOverlayBackground: '$sassy-color-overlay-background',
    sassyColorOverlayLight: '$sassy-color-overlay-light',
    sassyColorInternalPrimary: '$sassy-color-internal-primary',
    sassyColorInternalSecondary: '$sassy-color-internal-secondary',
    sassyColorInternalTertiary: '$sassy-color-internal-tertiary',
    sassyColorMarketingSale: '$sassy-color-marketing-sale',
    sassyColorNftWine: '$sassy-color-nft-wine',
    sassyColorMutedAquamarine: '$sassy-color-muted-aquamarine',
    sassyColorMedalBronze: '$sassy-color-medal-bronze',
    sassyColorMedalSilver: '$sassy-color-medal-silver',
    sassyColorMedalGold: '$sassy-color-medal-gold',
    sassyColorMedalPlatinum: '$sassy-color-medal-platinum',
    sassyColorPinterestPrimary: '$sassy-color-pinterest-primary',
    sassyColorFacebookPrimary: '$sassy-color-facebook-primary',
    sassyColorInstagramPrimary: '$sassy-color-instagram-primary',
    sassyColorLinkedinPrimary: '$sassy-color-linkedin-primary',
    sassyColorTwitterPrimary: '$sassy-color-twitter-primary',
    sassyColorDesignManagerPrimary: '$sassy-color-design-manager-primary',
    sassyColorDesignManagerSecondary: '$sassy-color-design-manager-secondary',
    sassyColorDesignManagerTertiary: '$sassy-color-design-manager-tertiary',
    sassyColorTradePrimary: '$sassy-color-trade-primary',
    sassyColorTradeSecondary: '$sassy-color-trade-secondary',
    sassyColorTradeTertiary: '$sassy-color-trade-tertiary',
    sassyColorTradeMember: '$sassy-color-trade-member',
} as const;

export type SassyColorNames = keyof typeof colors;
export type SassyColorValues = (typeof colors)[SassyColorNames];
